// Generated for @nava/participant-copy: Clair's default texts in Czech. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Czech. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_CS = {
    'landing.changeLanguage': 'Změnit jazyk',
    'common.language': 'Jazyk',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'S Clair můžete mluvit ve více než 80 jazycích.',
    'common.seeLanguages': 'Zobrazit jazyky',
    'footer.poweredBy': 'Provozuje',
    'landing.heading': 'Zveme vás na krátký rozhovor.',
    'landing.intro': 'Společnost {company} by ráda slyšela, jak se vám daří. Budete mluvit s Clair, AI asistentkou, kdy se vám to hodí.',
    'landing.continue': 'Pokračovat',
    'preflight.title': 'Potřebujeme ještě pár věcí',
    'preflight.checkInSubtitle': 'Projděte seznam níže a začněte rozhovor.',
    'preflight.actions.expandItem': 'Rozbalit {{item}}',
    'preflight.microphone.title': 'Přístup k mikrofonu',
    'preflight.microphone.checkInPrivacy': 'Váš hlas slouží k rozhovoru s Clair, AI asistentkou. Rozhovor se nahrává a přepisuje, záznam pak dostane {company}. Všechna data jsou šifrována a bezpečně uložena.',
    'preflight.microphone.readMore': 'Přečíst více',
    'preflight.microphone.grantAccess': 'Povolit přístup',
    'preflight.microphone.indicatorAction': 'Povolit přístup k mikrofonu',
    'preflight.microphone.accessGranted': 'Přístup povolen',
    'preflight.microphone.errorHelper': 'Zkontrolujte nastavení prohlížeče a zkuste to znovu.',
    'preflight.microphone.browserNotSupported': 'Váš prohlížeč nepodporuje nahrávání zvuku. Použijte Chrome, Firefox nebo Safari.',
    'preflight.terms.title': 'Soukromí a souhlas',
    'preflight.terms.checkInPrivacy': 'Tento rozhovor vede Clair, AI asistentka, a jeho zadavatelem je {company}. Vaše odpovědi dostane {company}. Nikdy nebudou použity k reklamě. Rozhovor můžete kdykoli ukončit.',
    'preflight.terms.readMore': 'Přečíst více',
    'preflight.terms.accept': 'Ano, souhlasím',
    'preflight.terms.indicatorAction': 'Přijmout podmínky soukromí a souhlasu',
    'preflight.terms.accepted': 'Přijato',
    'preflight.terms.rememberConsent': 'Zapamatovat si můj souhlas na 30 dní',
    'preflight.terms.rememberConsentCallTooltip': 'Souhlas se ukládá pouze pro tento hovor v tomto prohlížeči na 30 dní.',
    'quickStart.agree': 'Souhlasím',
    'quickStart.back': 'Zpět',
    'quickStart.cancel': 'Zrušit',
    'preflight.startCheckIn': 'Začít rozhovor',
    'preflight.preparingCheckIn': 'Připravujeme rozhovor...',
    'preflight.preparingCheckInDelayedTitle': 'Připravujeme rozhovor.',
    'preflight.preparingCheckInDelayedSubtitle': 'Stále pracujeme, počkejte prosím.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Trvá to déle, než se očekávalo.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Děkujeme za trpělivost.',
    'preflight.checkInPreparationFailedTitle': 'Rozhovor se nepodařilo připravit',
    'preflight.checkInPreparationFailedMessage': 'Některé soubory rozhovoru se nepodařilo načíst. Zkontrolujte připojení a zkuste to znovu.',
    'preflight.retryPreparation': 'Zkusit znovu',
    'interview.status.connecting': 'Připojování',
    'interview.status.speaking': 'Mluví',
    'interview.status.listening': 'Poslouchá',
    'interview.status.thinking': 'Přemýšlí',
    'interview.question': 'Otázka {{current}} z {{total}}',
    'interview.mainQuestion': 'Hlavní otázka {{current}} z {{total}}',
    'interview.recording': 'Vaše odpověď se nahrává...',
    'interview.endInterview': 'Ukončit rozhovor',
    'interview.muteTooltip': 'Ztlumit mikrofon',
    'interview.unmuteTooltip': 'Zapnout mikrofon',
    'interview.pauseTooltip': 'Dát si pauzu',
    'interview.resumeTooltip': 'Pokračovat v rozhovoru',
    'interview.subtitleTooltip.show': 'Zobrazit titulky (CC)',
    'interview.subtitleTooltip.hide': 'Skrýt titulky (CC)',
    'interview.toggleChat': 'Raději psát',
    'interview.toggleVoice': 'Raději mluvit',
    'interview.chatTooltip.type': 'Napsat odpověď místo mluvení',
    'interview.chatTooltip.speak': 'Říct odpověď místo psaní',
    'interview.chatTooltip.unavailable': 'Dostupné po připojení',
    'interview.chatDiscoveryHint': 'Nemůžete mluvit? Klepněte a pište',
    'interview.chatPlaceholder': 'Napište zprávu...',
    'interview.sendMessage': 'Odeslat',
    'interview.chat.warmHeader': 'Nespěchejte, počkám, než dopíšete',
    'interview.chat.newlineHint': 'Shift + Enter pro nový řádek',
    'interview.chat.aiVoiceOn': 'Hlas zapnutý',
    'interview.chat.aiVoiceOff': 'Hlas vypnutý',
    'interview.chat.backToVoice': 'Zpět na hlas',
    'interview.audio.controls': 'Nastavení zvuku',
    'interview.audio.callVolume': 'Hlasitost hovoru',
    'interview.audio.muteSpeaker': 'Ztlumit reproduktor',
    'interview.audio.unmuteSpeaker': 'Zapnout zvuk reproduktoru',
    'interview.audio.microphone': 'Mikrofon',
    'interview.audio.speaker': 'Reproduktor',
    'interview.audio.device': 'Zvukové zařízení',
    'interview.audio.linkedRouting': 'Telefon ovládá mikrofon a reproduktor společně.',
    'interview.audio.phoneSpeaker': 'Reproduktor telefonu',
    'interview.audio.phoneEarpiece': 'Sluchátko telefonu',
    'interview.audio.bluetoothHeadset': 'Bluetooth sluchátka',
    'interview.audio.wiredHeadset': 'Drátová sluchátka',
    'interview.audio.usbAudio': 'Zvuk přes USB',
    'interview.audio.systemDefault': 'Výchozí nastavení systému',
    'interview.audio.changeFailed': 'Zvukové zařízení se nepodařilo přepnout.',
    'interview.networkQuality.excellent': 'Kvalita připojení je výborná.',
    'interview.networkQuality.good': 'Kvalita připojení je dobrá.',
    'interview.networkQuality.poor': 'Kvalita připojení je slabá.',
    'interview.networkQuality.bad': 'Kvalita připojení je špatná.',
    'interview.networkQuality.offline': 'Připojení je offline.',
    'interview.pauseModal.title': 'Rozhovor je pozastavený',
    'interview.pauseModal.timeRemaining': 'Zbývá {{time}}',
    'interview.pauseModal.timeoutWarning': 'Pokud zůstanete v pauze, rozhovor brzy skončí sám.',
    'interview.pauseModal.resume': 'Pokračovat v rozhovoru',
    'interview.pauseModal.end': 'Ukončit rozhovor',
    'interview.endConfirm.title': 'Ukončit rozhovor?',
    'interview.endConfirm.body': 'Po ukončení se už nebudete moci vrátit. Dosavadní průběh bude uložen.',
    'interview.endConfirm.cancel': 'Pokračovat v rozhovoru',
    'interview.endConfirm.end': 'Ukončit rozhovor',
    'complete.checkInTitle': 'Děkujeme za váš čas',
    'complete.checkInMessage': 'Vaše odpovědi dostane tým společnosti {company}.',
    'studyClosed.checkInTitle': 'Tento rozhovor je uzavřený',
    'studyClosed.checkInMessage': 'Děkujeme za váš zájem, rozhovor už nepřijímá odpovědi.',
    'studyNotOpen.checkInTitle': 'Tento rozhovor ještě není otevřený',
    'studyNotOpen.checkInMessage': 'Zkuste odkaz otevřít později.',
    'studyNotReady.checkInTitle': 'Tento rozhovor je téměř připravený',
    'studyNotReady.checkInMessage': 'Zkuste odkaz otevřít za pár minut.',
    'participantLinkCompleted.checkInTitle': 'Tento rozhovor už proběhl',
    'participantLinkCompleted.checkInMessage': 'Děkujeme za váš čas, nemusíte už nic dělat.',
    'loading.interview': 'Načítáme rozhovor...',
    'browserHelp.title': 'Otevřete v prohlížeči',
    'browserHelp.description': 'Vestavěný prohlížeč této aplikace může omezovat přístup k mikrofonu. Pro nejlepší zážitek otevřete odkaz v prohlížeči {{browserOptions}}.',
    'browserHelp.namedDescription': 'Vestavěný prohlížeč aplikace {{app}} může omezovat přístup k mikrofonu. Pro nejlepší zážitek otevřete odkaz v prohlížeči {{browserOptions}}.',
    'browserHelp.appleBrowsers': 'Safari nebo Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge nebo Chrome',
    'browserHelp.otherBrowsers': 'Chrome nebo jiný prohlížeč',
    'browserHelp.openSafari': 'Otevřít v Safari',
    'browserHelp.copyLink': 'Kopírovat odkaz',
    'browserHelp.copied': 'Odkaz zkopírován. Vložte ho do prohlížeče.',
    'browserHelp.manualCopy': 'Automatické kopírování se nezdařilo. Vyberte a zkopírujte odkaz níže.',
    'browserHelp.copyInstructions': 'Zkopírujte odkaz níže a vložte ho do jiného prohlížeče. V nabídce aplikace můžete také vyhledat možnost otevření této stránky ve výchozím prohlížeči.',
    'browserHelp.linkLabel': 'Odkaz na rozhovor',
    'browserHelp.continueAnyway': 'Přesto pokračovat',
    'preflight.microphone.recovery.denied': 'Přístup k mikrofonu byl odepřen.',
    'preflight.microphone.recovery.timedOut': 'Žádost o přístup k mikrofonu trvala příliš dlouho. Zkontrolujte, zda prohlížeč zobrazuje žádost o oprávnění, a zkuste to znovu.',
    'preflight.microphone.recovery.notFound': 'Nebyl nalezen žádný mikrofon. Připojte mikrofon a zkuste to znovu.',
    'preflight.microphone.recovery.notReadable': 'Mikrofon se nepodařilo zapnout. Zavřete ostatní aplikace, které ho používají, a zkuste to znovu.',
    'preflight.microphone.recovery.failed': 'Nepodařilo se získat přístup k mikrofonu. Zkontrolujte mikrofon a zkuste to znovu.',
    'preflight.microphone.recovery.retry': 'Zkusit znovu',
    'preflight.microphone.recovery.close': 'Zavřít',
    'preflight.microphone.recovery.helpTitle': 'Povolit přístup k mikrofonu',
    'preflight.microphone.recovery.helpDescription': 'Přístup k mikrofonu je stále blokován. Prohlížeč si možná zapamatoval vaši předchozí volbu a znovu se na oprávnění neptá.',
    'preflight.microphone.recovery.safariMacSettings': 'Na řádku nabídek Safari vyberte Safari > Nastavení > Webové stránky > Mikrofon. Najděte tento web v seznamu.',
    'preflight.microphone.recovery.chromiumSettings': 'Klikněte na ikonu nastavení webu vlevo od adresního řádku a vyberte Nastavení webu > Mikrofon.',
    'preflight.microphone.recovery.siteSettings': 'Otevřete oprávnění tohoto webu pomocí ikony nebo nabídky vedle adresního řádku nebo v nastavení webů v prohlížeči.',
    'preflight.microphone.recovery.allowMicrophone': 'Povolte tomuto webu přístup k mikrofonu, vraťte se sem a vyberte „Zkusit znovu“. Pokud vás prohlížeč vyzve k opětovnému načtení stránky, udělejte to.',
    'preflight.microphone.recovery.deviceSettings': 'Pokud je přístup již povolen, zkontrolujte v nastavení zařízení, zda tento prohlížeč smí používat mikrofon.',
    'microphoneQuality.title': 'Kvalita mikrofonu',
    'microphoneQuality.instructions': 'Začněte na několik sekund mluvit, abychom mohli ověřit, jak dobře vás slyšíme.',
    'microphoneQuality.recoveryMessage': 'Neslyšíme vás. Pokud právě telefonujete, nejprve hovor ukončete. Zavřete ostatní aplikace, které používají mikrofon, a zkuste to znovu.',
    'microphoneQuality.poor': 'Slabá',
    'microphoneQuality.almostThere': 'Téměř hotovo',
    'microphoneQuality.perfect': 'Perfektní!',
    'microphoneQuality.waiting': 'Čekáme na zvuk...',
    'microphoneQuality.from': 'Z',
    'microphoneQuality.defaultDevice': 'Výchozí mikrofon',
    'microphoneQuality.helpText': 'Mluvte prosím hlasitěji nebo se přibližte k mikrofonu',
    'microphoneQuality.done': 'Hotovo',
    'startupRecovery.title': 'Rozhovor se nepodařilo spustit',
    'startupRecovery.failed': 'Nepodařilo se připojit ke službě rozhovorů. Zkuste to znovu.',
    'startupRecovery.timedOut': 'Připojení trvalo příliš dlouho. Zkuste to znovu.',
    'startupRecovery.cancelled': 'Připojení bylo zrušeno. Až budete připraveni, můžete to zkusit znovu.',
    'startupRecovery.microphone': 'Nepodařilo se získat přístup k mikrofonu. Zkontrolujte oprávnění a zkuste to znovu.',
    'startupRecovery.delayed': 'Stále se připojujeme. Trvá to déle než obvykle…',
    'startupRecovery.retry': 'Zkusit znovu',
    'startupRecovery.support': 'Referenční kód pro podporu',
    'startupRecovery.copy': 'Kopírovat kód',
    'startupRecovery.copied': 'Zkopírováno',
    'startupRecovery.checking': 'Kontrola připojení…',
    'startupRecovery.unavailable': 'Nepodařilo se ověřit',
    'startupRecovery.advice': 'Tato kontrola testuje pouze dostupnost služeb. Přesto můžete zkusit spustit rozhovor. Pokud se to nepodaří, zkuste jiný prohlížeč nebo síť.',
    'startupRecovery.checkAgain': 'Znovu zkontrolovat připojení...',
    'connectionDetails.quality': 'Kvalita sítě',
    'connectionDetails.excellent': 'Výborná',
    'connectionDetails.good': 'Dobrá',
    'connectionDetails.poor': 'Slabá',
    'connectionDetails.bad': 'Špatná',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Nezkontrolováno',
    'connectionDetails.lastChecked': 'Poslední kontrola',
    'connectionDetails.warning': 'Nepodařilo se ověřit připojení: {{services}}.',
    'connectionDetails.navaApi': 'API Clair',
    'connectionDetails.interviewApi': 'Služba rozhovorů Clair',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Obnovit test připojení',
    'connectionDetails.success': 'Kontrola připojení proběhla úspěšně.',
    'connection.error': 'Chyba připojení',
    'connection.errorDefault': 'Nepodařilo se připojit ke službě rozhovorů',
    'connection.retry': 'Zkusit znovu',
    'versionRefresh.message': 'Je dostupná nová verze. Až budete připraveni, obnovte prohlížeč.',
    'versionRefresh.action': 'Obnovit',
    'cookies.banner.title': 'Vážíme si vašeho soukromí',
    'cookies.banner.message': 'Používáme cookies k optimalizaci vašeho zážitku, porozumění používání produktu a podpoře relevantního marketingu. Zvolte <bold>„Přijmout vše“</bold>, chcete-li souhlasit se všemi cookies, nebo <bold>„Spravovat nastavení“</bold>, chcete-li nastavení upravit.',
    'cookies.banner.privacyPolicy': 'Zásady ochrany soukromí',
    'cookies.banner.acceptAll': 'Přijmout vše',
    'cookies.banner.managePreferences': 'Spravovat nastavení',
    'cookies.modal.title': 'Nastavení cookies',
    'cookies.modal.description': 'Když navštívíte Clair, můžeme pomocí souborů cookie a podobných technologií ukládat nebo načítat údaje o vás. Nezbytné soubory cookie zajišťují fungování webu. Volitelná nastavení můžete kdykoli změnit.',
    'cookies.modal.readMore': 'Přečtěte si více v',
    'cookies.modal.save': 'Uložit',
    'cookies.modal.close': 'Zavřít nastavení cookies',
    'cookies.modal.essential.title': 'Nezbytné',
    'cookies.modal.essential.description': 'Vyžadováno pro základní fungování webu. Nezbytné cookies nelze vypnout.',
    'cookies.modal.analytics.title': 'Analytika',
    'cookies.modal.analytics.description': 'Pomáhá Clair pochopit, jak web funguje, jak ho návštěvníci používají a zda se nevyskytují technické problémy.',
    'invitation.subject': 'Společnost {company} vás zve na krátký rozhovor',
    'invitation.greeting': 'Dobrý den, {name},',
    'invitation.body': 'Rádi bychom slyšeli, jak se vám daří.',
    'invitation.aiNotice': 'Budete mluvit s Clair, naší AI asistentkou. Většině lidí se snáz mluví upřímně s AI než s člověkem a můžete to udělat, kdy se vám to hodí, v práci nebo doma.',
    'invitation.button': 'Začít rozhovor',
    'invitation.fallbackLink': 'Nebo vložte tento odkaz do prohlížeče:',
    'invitation.footer': 'Tuto zprávu dostáváte, protože využíváte služby společnosti {company}. Rozhovor vede jejím jménem Clair, AI asistentka.',
    'invitation.optOut': 'Už mi tyto zprávy neposílejte',
    'sms.invite': 'Společnost {company} vás zve na krátký rozhovor:',
    'sms.stop': 'Odhlásit SMS:',
};
//# sourceMappingURL=cs.js.map